import {
	Box,
	Fade,
	IconButton,
	Tooltip,
} from "@mui/material"
import {addSelectedArticle, selectIsSelectingArticles} from "../../../reducers/selectedArticlesSlice"
import {useDispatch, useSelector} from "react-redux"
import {useEffect, useMemo, useRef, useState} from "react"
import {
	CheckBox,
	CheckBoxOutlineBlankOutlined,
	//CheckBoxOutlined,
} from "@mui/icons-material"
import useIsMacOS from "../../../hooks/useIsMacOS"
import {useWorkspaceContext} from "../../../pages/Dashboard"

export function ArticleSelectionBox(
	{
		isHovered,
		articleWorkspace,
		isImported,
		isOpen,
		id,
		selectedArticles,
	}
){
	const dispatch = useDispatch()
	const {workspaceId} = useWorkspaceContext()
	const isSelectingSelector = useMemo(() => selectIsSelectingArticles(workspaceId), [workspaceId])
	const isSelecting = useSelector(isSelectingSelector)
	const anchorElRef = useRef(null)
	const [isSelected, setIsSelected] = useState(false)
	const isMacOS = useIsMacOS()

	useEffect(() => {
		setIsSelected(selectedArticles[id])
	}, [selectedArticles, articleWorkspace])

	return (
		<Box
			sx={{
				position: "absolute",
				top:0,
				right: 0,
				//borderRadius: "4px",
				borderBottomLeftRadius: "4px",
				overflow: "hidden"
			}}
		>
			<Fade
				in={isHovered || isOpen || isSelecting}
				mountOnEnter
				unmountOnExit
				sx={{
					height: "24px"
				}}
			>
				<Box
					ref={anchorElRef}
					sx={{
						height: "100%",
						color: "white",
						display: "inline-flex",
						flexDirection: "row",
						alignItems: "center",
						justifyContent: "center",
						gap: "2px",
						padding: "0 4px 0 0px",
					}}
				>
					<Box
						display={(((isHovered || isOpen) && isImported) || (isImported && isSelecting)) ? "initial" : "none"}
					>
						<Tooltip
							title={"Select article"}
							placement={"top"}
						>
							<IconButton
								sx={{
									minWidth: isMacOS ? "38px" : "24px",
								}}
								onClick={() => dispatch(addSelectedArticle(articleWorkspace))}
							>
								{ isSelected ?
									<CheckBox fontSize={"small"} sx={{
										color: "dragBar.importedDark"
									}}/>
									:
									<CheckBoxOutlineBlankOutlined fontSize={"small"} />
								}
							</IconButton>
						</Tooltip>
					</Box>
				</Box>
			</Fade>
		</Box>
	)
}